"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isDefined = void 0;
/**
 * @summary Checks that a value is defined.
 *
 * Checks that a value is defined. Both `null` and `undefined` are considered not defined, but
 * falsy values like `0` or `false` are defined. The checked value will also reflect accordingly
 * in the TypeScript type system.
 *
 * @param {any} value
 * @returns {boolean}
 *
 * @example
 * const name = isDefined(user) ? user.name : 'Anonymous';
 */
function isDefined(value) {
    return value != null;
}
exports.isDefined = isDefined;
